import { withTextComponent, withTemplate, applyAsAttributes } from '@updater/ui-custom-element';
import { withFormValidation } from '@updater/ui-form-element';
import '@updater/ui-fa-icon';

var styles = "upd-select {\n  position: relative;\n  display: inline-block;\n}\n\n.upd-select__select {\n  width: 100%;\n  height: 100%;\n  padding: 0 2.5em 0 0.625em;\n  font-size: 1rem;\n  font-weight: 300;\n  background: none;\n  border: none;\n  border-radius: inherit;\n  color: inherit;\n  -webkit-transition: border-color ease-in-out 0.15s, background-color ease-in-out 0.15s;\n  transition: border-color ease-in-out 0.15s, background-color ease-in-out 0.15s\n}\n\n.upd-select__select:hover,\n  .upd-select__select:focus {\n  border-color: #2b7499;\n}\n\n.upd-select__select {\n\n  /* The remaining rules remove native <select> styles from all supported browsers. */\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  outline: none;\n\n  /* https://stackoverflow.com/a/18878556/89594 */\n}\n\n.upd-select__select::-ms-expand {\n  display: none;\n}\n\n.upd-select__select {\n\n  /* https://stackoverflow.com/a/18853002/89594 */\n}\n\n.upd-select__select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #000;\n}\n\n/* Moving padding from upd-tile to the select element so that clicking the\n * padding opens the select. There’s no way to programmatically open a select. */\n\nupd-tile > upd-select {\n  padding: 0;\n}\n\nupd-tile > upd-select .upd-select__select {\n  padding: 0.5625em 2.5em 0.5625em 1.25em;\n}\n\n.upd-select__select-icon {\n  position: absolute;\n  font-size: 0.75em;\n  right: 1.25em;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n  pointer-events: none;\n}\n\nupd-select.upd-select-empty .upd-select__select,\n  upd-select.upd-select-empty .upd-select__select-icon {\n  color: #bababb;\n}\n";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var html = '\n  <select class="upd-select__select"></select>\n  <upd-fa-icon class="upd-select__select-icon" name="chevron-down"></upd-fa-icon>\n';

var OBSERVED_ATTRIBUTES = ['name', 'placeholder', 'required', 'value'];

var IS_IE_OR_EDGE = document.documentMode || /Edge/.test(navigator.userAgent);

var Select = function (_withFormValidation) {
  _inherits(Select, _withFormValidation);

  function Select() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Select);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Select.__proto__ || Object.getPrototypeOf(Select)).call.apply(_ref, [this].concat(args))), _this), _this._handleChangeOrInput = function (event) {
      // Stop the internal `input`'s event at this level to prevent duplicate events.
      event.stopPropagation();

      var value = event.target.value,
          type = event.type;


      if (_this.value === value) {
        // There may be multiple options with the same value, but only the first
        // of them (in DOM tree order) can be selected.
        // https://www.w3.org/TR/html5/sec-forms.html#dom-htmlselectelement-value
        // Force the internal `input`'s selection back to the first option with a
        // matching `value`. E.g. this handles the case where selecting the empty
        // option results in the placeholder being selected (both have empty
        // string as the option value).
        _this._input.value = value;
      }

      _this.value = value;

      if (IS_IE_OR_EDGE) {
        // this resolves an issue where an invalid state
        // takes two selections to clear.
        setTimeout(function () {
          _this.checkValidity();
        });
      } else {
        _this.checkValidity();
      }

      // Re-dispatch interaction events with `composed` and `detail`.
      _this.dispatchEvent(new CustomEvent(type, Object.assign({}, event, {
        bubbles: true,
        composed: true,
        detail: value
      })));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Select, [{
    key: 'connected',
    value: function connected() {
      this.value = this.value || '';

      var template = document.createElement('template');
      template.innerHTML = '<style>' + styles + '</style>';
      var style = template.content.cloneNode(true);

      this.appendChild(style);
      this.appendChild(this._template);

      this._input = this.querySelector('select');
      this._input.addEventListener('change', this._handleChangeOrInput);
      this._input.addEventListener('input', this._handleChangeOrInput);
    }
  }, {
    key: 'disconnected',
    value: function disconnected() {
      this._input.removeEventListener('change', this._handleChangeOrInput);
      this._input.removeEventListener('input', this._handleChangeOrInput);
    }
  }, {
    key: 'updated',
    value: function updated(_ref2, _ref3) {
      var _this2 = this;

      var options = _ref2.options,
          placeholder = _ref2.placeholder,
          required = _ref2.required,
          value = _ref2.value;
      var oldOptions = _ref3.options,
          oldPlaceholder = _ref3.placeholder,
          oldRequired = _ref3.required;

      if (options !== oldOptions || placeholder !== oldPlaceholder || required !== oldRequired) {
        this._input.innerHTML = ''; // Clear existing options.

        if (placeholder) {
          this._input.appendChild(createPlaceholderOption(placeholder));
        }

        if (!required) {
          // Allow user to remove a selection if the field isn't required.
          this._input.appendChild(createOption(''));
        }

        (options || []).forEach(function (value) {
          _this2._input.appendChild(createOption(value));
        });
      }

      // There may be multiple options with the same value, but only the first of
      // them (in DOM tree order) can be selected.
      // https://www.w3.org/TR/html5/sec-forms.html#dom-htmlselectelement-value
      var children = Array.from(this._input.children);
      var selectedIndex = children.findIndex(function (child) {
        return child.value === value;
      });
      children.forEach(function (child, index) {
        applyAsAttributes(child, { selected: index === selectedIndex });
      });

      if (value) {
        this.classList.remove('upd-select-empty');
      } else {
        this.classList.add('upd-select-empty');
      }

      applyAsAttributes(this._input, { required: required, value: value });
    }
  }]);

  return Select;
}(withFormValidation(withTemplate(html)(withTextComponent())));

/**
 * Creates an `<option>` element from a string or object. In the former case,
 * the value is the text content of the option. In the latter case, the object's
 * keys are mapped to the option's attributes.
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/option#Attributes
 *
 * @param {String|Object} source
 * @return {HTMLOptionElement}
 */


Select.props = ['options'];
Select.observedAttributes = OBSERVED_ATTRIBUTES;
Select.reflectedAttributes = OBSERVED_ATTRIBUTES;
Select.attributeTypes = { required: 'boolean' };
function createOption(source) {
  var el = document.createElement('option');

  if ((typeof source === 'undefined' ? 'undefined' : _typeof(source)) === 'object') {
    var _source$disabled = source.disabled,
        disabled = _source$disabled === undefined ? false : _source$disabled,
        _source$label = source.label,
        label = _source$label === undefined ? '' : _source$label,
        _source$selected = source.selected,
        selected = _source$selected === undefined ? false : _source$selected,
        _source$value = source.value,
        value = _source$value === undefined ? '' : _source$value;


    applyAsAttributes(el, { disabled: disabled, label: label, selected: selected, value: value });

    // Should be redundant since we're setting the `label` attribute,
    // but FF doesn't yet support it:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=40545
    el.textContent = label;
  } else {
    el.textContent = source;
  }

  return el;
}

// https://stackoverflow.com/a/5859221/89594
function createPlaceholderOption(label) {
  return createOption({
    disabled: true,
    label: label
  });
}

customElements.define('upd-select', Select);

export default Select;
